// v3 observations: one per enabled leading metric (use case × record level), holding the TODAY
// value (Q61). Mirrors engine/observations.ts (v2): reads the snapshot, never the engine, so the
// persistence stage can swap it in. A metric with no today / with-Clay split (accounts enrolled,
// tools displaced) records the entered value — that is its `today`.

import { z } from 'zod';

import type { ValueStory } from './value-story';

export const ObservationSchema = z.object({
  /** The Metric_Definition__c key, e.g. `uc-crm-enrichment-accounts`. */
  metricKey: z.string(),
  value: z.number(),
  source: z.enum(['Our assumption', 'Customer-provided']),
});

export type UseCaseObservation = z.infer<typeof ObservationSchema>;

export function extractUseCaseObservations(story: ValueStory): UseCaseObservation[] {
  const out: UseCaseObservation[] = [];
  for (const uc of story.useCases) {
    for (const m of uc.metrics) {
      if (!Number.isFinite(m.today)) continue;
      out.push({
        metricKey: m.key,
        value: m.today,
        source: m.assumed ? 'Our assumption' : 'Customer-provided',
      });
    }
  }
  return out;
}
